import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
interface SolidButtonProps {
  variantColor?: "light" | "dark";
}

/**
 * trainwell Solid Button according to the specs. Can be rendered in either
 * light purple or dark purple variants.
 */
export const SolidButton = styled(Button)<SolidButtonProps>(
  ({ theme, variantColor = "dark" }) => ({
    width: "100%",
    padding: theme.spacing(2, 3),
    borderRadius: theme.shape.borderRadius,
    textTransform: "none",
    ...(variantColor === "light"
      ? {
          backgroundColor: "#F8F7FC", // Light purple background
          color: "#4A4458", // Dark text color
          "&:hover": {
            backgroundColor: "#EFEEF4", // Slightly darker on hover
          },
        }
      : {
          backgroundColor: "#4A4458", // Dark purple background
          color: "#FFFFFF", // White text
          "&:hover": {
            backgroundColor: "#3D384A", // Slightly darker on hover
          },
        }),
  }),
);
